// Tiene que ir primero: parchea el DOM de Electron antes de que se cargue Blockly.
import './helpers/electronPolyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './themes/mui.ts';
import App from './app';

import '@styles/modals.scss';
import '@styles/toast.scss';
import './components/baseModule/fonts.css';
import './components/baseModule/modalBrowserComponent.scss';
import './index.scss';
import './themes/index.scss';


// enable HMR
if (module.hot) {
  module.hot.accept();
}

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
  document.getElementById('app'),
);
